class SilentCartUpdater {
  constructor() {
    this.initialized = false;
    this.initEventListeners();
  }

  initEventListeners() {
    // Use capture phase to intercept events before they reach the default handlers
    document.addEventListener('click', this.handleClick.bind(this), true);
    
    // Additionally, intercept direct input changes
    document.addEventListener('change', (event) => {
      const quantityInput = event.target.closest('.quantity-input');
      if (!quantityInput || !quantityInput.closest('.cart-drawer')) return;
      
      // Prevent default form submission
      event.preventDefault();
      event.stopImmediatePropagation();
      
      const newValue = parseInt(quantityInput.value);
      if (isNaN(newValue) || newValue < 1) return;
      
      this.updateCartItem(quantityInput.dataset.quantityVariantId, newValue, quantityInput);
    }, true);
    
    // Add event listener for upsell product buttons
    document.addEventListener('click', (event) => {
      const upsellButton = event.target.closest('.cart-upsell-add-button');
      if (!upsellButton) return;
      
      const variantId = parseInt(upsellButton.dataset.variantId);
      const productId = parseInt(upsellButton.dataset.productId);
      
      this.addUpsellToCart(variantId, productId);
    });
    
    // Mark as fully initialized after a short delay to ensure this runs after Shopify's handlers
    setTimeout(() => {
      this.initialized = true;
    }, 500);
  }
  
  handleClick(event) {
    if (!event.target.closest('.cart-drawer')) return;
    
    const quantityButton = event.target.closest('.quantity-button');
    if (!quantityButton) return;
    
    // Always stop propagation in capture phase to prevent default handlers
    event.stopPropagation();
    event.preventDefault();
    
    const quantityInput = quantityButton.closest('quantity-input').querySelector('.quantity-input');

    if (!quantityInput) return;
    
    const currentValue = parseInt(quantityInput.value);
    const isPlus = quantityButton.name === 'plus';
    const newValue = isPlus ? currentValue + 1 : Math.max(1, currentValue - 1);
    
    // Update the visual display immediately
    quantityInput.value = newValue;
    
    // Perform silent update
    this.updateCartItem(quantityInput.dataset.quantityVariantId, newValue, quantityInput);
  }
  
  async updateCartItem(variantId, quantity, inputElement) {
    if (!variantId) return;
    
    // Find the cart item container
    const cartItemRow = inputElement.closest('.cart-item');
    if (!cartItemRow) return;
    
    // Show loading state
    const loadingOverlay = cartItemRow.querySelector('.loading-overlay');
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    try {
      window.startCartSpinner()
      // Get current cart to find the line item key
      // const cartResponse = await fetch('/cart.js');
      // const cart = await cartResponse.json();
      
      // Find the item in the cart by variant ID
      // const cartItem = cart.items.find(item => item.variant_id === parseInt(variantId));
      // if (!cartItem) return;
      
      // Use line item key for the update
      const lineItemKey = inputElement.dataset.quantityVariantId
    
     
      // Send the update request
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: quantity,
          sections: ["cart-drawer", "cart-icon-bubble"]
        })
      });
      
      const updatedCart = await response.json();
      
      // Update the cart drawer with the response
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cart.renderContents(updatedCart);
      
      // Trigger cart update event
      // document.dispatchEvent(new CustomEvent('cart:silentupdate', { 
      //   detail: { cart: updatedCart }
      // }));
    } catch (error) {
      console.error('Error updating cart:', error);
      // Show error message if needed
    } finally {
      // Hide loading state
      if (loadingOverlay) loadingOverlay.classList.add('hidden');
    }
  }
  
  async updateCartUI(cart) {
    // if (!cart) return;
    
    // // Simple AJAX refresh of the drawer inner content
    // fetch('/cart?view=drawer')
    //   .then(response => response.text())
    //   .then(html => {
    //     const parser = new DOMParser();
    //     const newCartDocument = parser.parseFromString(html, 'text/html');
        
    //     // Replace the drawer inner content
    //     const drawerInner = document.querySelector('.drawer-inner');
    //     const newDrawerInner = newCartDocument.querySelector('.drawer-inner');
        
    //     if (drawerInner && newDrawerInner) {
    //       drawerInner.innerHTML = newDrawerInner.innerHTML;
          
    //       // Find cart-drawer-items component to reattach all events
    //       const cartDrawerItems = document.querySelector('cart-drawer-items');
    //       if (cartDrawerItems) {
    //         // 1. Re-attach event listeners for close buttons
    //         const closeButtons = drawerInner.querySelectorAll('.drawer-close');
    //         closeButtons.forEach(button => {
    //           button.addEventListener('click', function() {
    //             this.closest('cart-drawer').close();
    //           });
    //         });
            
    //         // 2-5. Reattach all other event listeners by using CartDrawerItems methods
    //         if (typeof cartDrawerItems.reattachQuantityListeners === 'function') {
    //           cartDrawerItems.reattachQuantityListeners(drawerInner);
    //           cartDrawerItems.reattachRemoveButtonListeners(drawerInner);
    //           cartDrawerItems.reattachTermsCheckbox(drawerInner);
    //           cartDrawerItems.reattachCollapsibleSections(drawerInner);
    //         }
    //       }
          
    //       // Re-attach upsell product event listeners
    //       this.reattachUpsellEventListeners(drawerInner);
          
    //       // 6. Force update of the discount tier progress
    //       if (typeof updateDiscountTierProgress === 'function') {
    //         setTimeout(() => {
    //           updateDiscountTierProgress(cart.total_price);
    //         }, 100);
    //       }
    //     }
        
    //     // Notify that cart was updated
    //     document.dispatchEvent(new CustomEvent('cart:updated', { 
    //       detail: { cart: cart }
    //     }));
    //   })
    //   .catch(error => {
    //     console.error('Error refreshing cart drawer:', error);
    //   });
  }
  
  formatMoney(cents, withCurrency = false) {
    const currencySymbol = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    const amount = (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: currencySymbol
    });
    
    return amount;
  }
  
  async addUpsellToCart(variantId, productId) {
    if (!variantId) return;
    
    // Find and show loading state on the button
    const addButton = document.querySelector(`.cart-upsell-add-button[data-variant-id="${variantId}"]`);
    if (addButton) {
      addButton.classList.add('loading');
      addButton.setAttribute('disabled', 'disabled');
      addButton.innerHTML = '<div class="loading-spinner"></div>';
    }
    
    window.startCartSpinner()
    
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: ["cart-drawer", "cart-icon-bubble"]
        })
      }).then((response) => response.json()).then(response => {
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        setTimeout(() => { this.cart.renderContents(response) });
      });
  }

  async removeCartItem(lineId, buttonElement) {
    if (!lineId) return;
    
    // Find the cart item row
    const cartItemRow = buttonElement?.closest('tr.cart-item');
    
    // Show loading state
    if (cartItemRow) {
      const loadingOverlay = cartItemRow.querySelector('.loading-overlay');
      if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    }
    
    if (buttonElement) {
      buttonElement.classList.add('loading');
      buttonElement.setAttribute('disabled', 'disabled');
    }
    
    try {
      // Get current cart to find the item key
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find the item in the cart
      let itemKey;
      
      // If lineId is a number (index), find the corresponding item key
      if (!isNaN(parseInt(lineId))) {
        const lineIndex = parseInt(lineId) - 1;
        if (lineIndex >= 0 && lineIndex < cart.items.length) {
          itemKey = cart.items[lineIndex].key;
        }
      } else {
        // If lineId is already a key, use it directly
        itemKey = lineId;
      }
      
      if (!itemKey) {
        console.error('Could not find item to remove');
        return;
      }
      
      window.startCartSpinner()
      // Remove the item
   await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
          sections: ["cart-drawer", "cart-icon-bubble"]
        })
      }).then((response) => response.json()).then(response => {
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        setTimeout(() => { this.cart.renderContents(response) });
      });
      
      // const updatedCart = await response.json();
      
      // // Refresh the cart drawer using the section rendering API
      // await this.refreshCartDrawer();
      
      // // Signal that the cart was updated
      // document.dispatchEvent(new CustomEvent('cart:silentupdate', { 
      //   detail: { cart: updatedCart }
      // }));
      
    } catch (error) {
      console.error('Error removing item from cart:', error);
      
      // Show error message
      const errors = document.getElementById('cart-errors') || 
                    document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = 'Error removing item. Please try again.';
      }
    } finally {
      // Reset loading states
      if (cartItemRow) {
        const loadingOverlay = cartItemRow.querySelector('.loading-overlay');
        if (loadingOverlay) loadingOverlay.classList.add('hidden');
      }
      
      if (buttonElement) {
        buttonElement.classList.remove('loading');
        buttonElement.removeAttribute('disabled');
      }
    }
  }

  // Add a separate method to refresh the cart drawer using the section rendering API
  async refreshCartDrawer() {
    try {
      // Fetch the cart-drawer section HTML
      const response = await fetch('/cart?view=drawer');
      const html = await response.text();
      
      // Parse the HTML
      const parser = new DOMParser();
      const newCartDocument = parser.parseFromString(html, 'text/html');
      
      // Replace the drawer inner content
      const drawerInner = document.querySelector('.drawer-inner');
      const newDrawerInner = newCartDocument.querySelector('.drawer-inner');
      
      if (drawerInner && newDrawerInner) {
        drawerInner.innerHTML = newDrawerInner.innerHTML;
        
        // Re-attach event listeners for close buttons
        const closeButtons = drawerInner.querySelectorAll('.drawer-close');
        closeButtons.forEach(button => {
          button.addEventListener('click', function() {
            this.closest('cart-drawer').close();
          });
        });
        
        // Re-attach event listeners for quantity buttons
        this.reattachEventListeners(drawerInner);
        
        // Re-attach upsell product event listeners
        this.reattachUpsellEventListeners(drawerInner);
        
        // Update discount tier progress
        if (typeof updateDiscountTierProgress === 'function') {
          setTimeout(() => {
            updateDiscountTierProgress();
          }, 100);
        }
      }
      
      return true;
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
      return false;
    }
  }

  // Helper method to reattach event listeners
  reattachEventListeners(container) {
    // Reattach quantity input functionality
    const quantityInputs = container.querySelectorAll('quantity-input');
    quantityInputs.forEach(quantityInput => {
      const minusButton = quantityInput.querySelector('[name="minus"]');
      const plusButton = quantityInput.querySelector('[name="plus"]');
      const input = quantityInput.querySelector('.quantity-input');
      
      if (minusButton && input) {
        minusButton.addEventListener('click', () => {
          const currentValue = parseInt(input.value);
          if (currentValue > 1) {
            input.value = currentValue - 1;
            const event = new Event('change', { bubbles: true });
            input.dispatchEvent(event);
          }
        });
      }
      
      if (plusButton && input) {
        plusButton.addEventListener('click', () => {
          const currentValue = parseInt(input.value);
          input.value = currentValue + 1;
          const event = new Event('change', { bubbles: true });
          input.dispatchEvent(event);
        });
      }
    });
    
    // Reattach remove button functionality
    const removeButtons = container.querySelectorAll('cart-remove-button');
    removeButtons.forEach(button => {
      const actualButton = button.querySelector('button');
      if (actualButton) {
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.removeCartItem(actualButton.dataset.lineId, actualButton);
        });
      }
    });
  }

  // Add a new method to reattach upsell event listeners
  reattachUpsellEventListeners(container) {
    // 1. Handle metaobject upsell products (from cart-upsell-products.liquid)
    const addButtons = container.querySelectorAll('.add-to-cart-button');
    addButtons.forEach(button => {
      button.addEventListener('click', () => {
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;
        
        // Add loading state
        button.classList.add('loading');
        
        // Use silentCartUpdater to add the product (if available)
        if (window.silentCartUpdater) {
          window.silentCartUpdater.addUpsellToCart(variantId, button.getAttribute('data-product-id'));
        } else {
          window.startCartSpinner()
          // Fallback to direct fetch if silentCartUpdater is not available
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(data => {
            // Refresh the cart
            this.refreshCartDrawer();
            
            // Remove loading state
            button.classList.remove('loading');
          })
          .catch(error => {
            console.error('Error:', error);
            button.classList.remove('loading');
          });
        }
      });
    });
    
    // 2. Handle cart-drawer upsell products
    const cartUpsellButtons = container.querySelectorAll('.cart-upsell-add-button');
    cartUpsellButtons.forEach(button => {
      button.addEventListener('click', () => {
        const variantId = parseInt(button.dataset.variantId);
        const productId = parseInt(button.dataset.productId);
        
        if (window.silentCartUpdater) {
          window.silentCartUpdater.addUpsellToCart(variantId, productId);
        }
      });
    });
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  window.silentCartUpdater = new SilentCartUpdater();
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartItems=[]
    document.addEventListener('cart:updatedData', (event) => {
      this.updateCartData(event?.detail?.cart)
      // this.cartItems = event.detail.cart.items
    })
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    // this.renderUpsellProducts()
    this.firstRender = false
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  updateCartData(cart){

    console.log(cart,"cart 123456789")
   
   if(cart?.items){
        this.cartItems = cart.items
      }else{
        let found = false
        this.cartItems = this.cartItems?.map(item => {
          if(cart.variant_id===item?.variant_id){
            found = true
            return {
              ...cart
            } 
          }
          return item
         
        })
        if(!found){
          this.cartItems.push(cart)
        }
      }
  
      if(!this.firstRender && this.cartItems.length>0){
        this.renderUpsellProducts()
        this.firstRender = true
      }

  }

  open(triggeredBy) {
    const isCartPage = document.querySelector("cart-items");

    if (isCartPage) return;

    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer-inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer-inner") ||
          this.querySelector(".drawer-close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("cart-drawer-quick-view");
   if (window.matchMedia("(min-width: 768px)").matches) {
    document.body.style.overflow = "hidden";
    document.body.style.padding = "0 4px 0 0";
   }

    const animatedElements = this.querySelectorAll("[data-aos]");
    animatedElements.forEach((element) => {
      element.classList.add("aos-animate");
    });
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("cart-drawer-quick-view");
    if (window.matchMedia("(min-width: 768px)").matches) {
    document.body.style.overflow = "scroll";
    document.body.style.padding = "0";
    document.body.style.overflowX = "hidden";
    }

    const animatedElements = this.querySelectorAll(".aos-animate");
    animatedElements.forEach((element) => {
      element.classList.remove("aos-animate");
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderUpsellProducts(){

  
    const getUpsellProducts = document.querySelectorAll(".upsell-product-card")
    getUpsellProducts.forEach(product => {
      let discount =[]
      if(product.dataset.discount){
        discount = JSON.parse(product.dataset.discount)
      }
      const comparePrice = parseFloat(product.dataset.comparePrice)/100
      let price = parseFloat(product.dataset.price)/100
      const variantId = product.dataset.variantId
      const currencyFormat = product.dataset.currencyFormat
      const productHandle = product.dataset.productHandle
      let currentQuantity = 1
      


      function formatCurrency(amount, currency,currencyFormat) {
        const options = { style: 'currency', currency: currency };

        return new Intl.NumberFormat('en-US', options).format(amount);
      }
      const rate = parseFloat(Shopify.currency.rate);
      const item = this.cartItems.find(item => item.handle === (productHandle))

      console.log("dwqdwqdwqd")
      
      if(item){
        
        currentQuantity = this.cartItems.reduce((acc, item) => item.handle === (productHandle) ? acc + item.quantity : acc, 0) + 1
        let found = false

        discount.sort((a, b) => a.quantity - b.quantity)
       
        for (let i = 0; i < discount.length; i++) {
          const item = discount[i];
        
          if(item.quantity==currentQuantity){
            price = price - (item.discount_amount * rate)
            found = true
            break;
          }
        } 
       
        if(!found){
          price = price - (discount[discount.length-1].discount_amount * rate)

        }

      

      }
  


     

      console.log(price,"price 234123",rate,this.cartItems)
      
     
    
      let price_sale = product.querySelector(".price-sale");
      let price_compare = product.querySelector(".price-compare");
      let sale_percentage = product.querySelector(".upsell-discount-badge")


      if(price_sale){
        price_sale.innerHTML = formatCurrency((price),Shopify.currency.active)
      }
      
      if(price_compare){
        price_compare.innerHTML = formatCurrency((comparePrice),Shopify.currency.active)
      }
      if(sale_percentage && price<comparePrice){
        let discount_badge = sale_percentage.dataset.discountBedge
        sale_percentage.innerHTML = discount_badge.replace("*discount_percentage*",Math.round((comparePrice-price)/comparePrice*100))
      }
      
    })

  }
  async renderContents(parsedState) {

    this.updateCartData(parsedState)
    // console.log("parsedState",parsedState)
    this.querySelector(".drawer-inner").classList.contains("is-empty") &&
      this.querySelector(".drawer-inner").classList.remove("is-empty");
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );

      this.renderUpsellProducts()
    });

    

    

    // Add this to update discount tier progress
    if (window.updateDiscountTierProgress) {
      setTimeout(() => {
        window.updateDiscountTierProgress(parsedState.total_price);
      }, 100);
    }


    document.dispatchEvent(new CustomEvent('cart:refreshed', { detail: parsedState }));
     
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Add this new method to handle upsell product additions
  addToCart(button, variantId) {
    // Add loading state
    button.classList.add('loading');
    window.startCartSpinner();
    
    // Check if this variant already exists in this.cartItems
    const existingItem = this.cartItems.find(item => item.variant_id === parseInt(variantId));
  
    let fetchPromise;
    
    if (existingItem) {
      // Item exists, update quantity
      fetchPromise = fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: existingItem.key,
          quantity: existingItem.quantity + 1,
          sections: ["cart-drawer", "cart-icon-bubble"]
        })
      });
    } else {
      // Item doesn't exist, add it
      fetchPromise = fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: ["cart-drawer", "cart-icon-bubble"]
        })
      });
    }
    
    fetchPromise
      .then(response => response.json())
      .then(data => {
        // Use this instance's renderContents method
        setTimeout(() => { this.renderContents({
          ...data?.items?.[0]||{},
          sections:data?.sections
        }) });
        
        // Remove loading state
        button.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error:', error);
        button.classList.remove('loading');
      });
  }
}

customElements.define("cart-drawer", CartDrawer);

// Expose the CartDrawer addToCart method globally
window.CartUpsell = window.CartUpsell || {};
window.CartUpsell.addToCart = function(button, variantId) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.addToCart(button, variantId);
  }
};


